import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type EditPropsType = {
  onClick: () => void;
};

export const Edit: React.FC<EditPropsType> = ({ onClick }) => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const label = t('ACTIONS.EDIT');

  return (
    <Tooltip label={label}>
      <UnstyledButton onClick={handleClick} aria-label={label}>
        <FontAwesomeIcon icon={faPen} />
      </UnstyledButton>
    </Tooltip>
  );
};
